/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .circle-color[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;border-radius:50%;border:1px solid #e7eaec;font-weight:400;color:#fff}@media (max-width:1100px){[_nghost-%COMP%]   .circle-color[_ngcontent-%COMP%]{font-size:10px!important}}@media (min-width:1101px){[_nghost-%COMP%]   .circle-color[_ngcontent-%COMP%]{font-size:1.6666666667em!important}}[_nghost-%COMP%]   .circle-color.square[_ngcontent-%COMP%]{border-radius:6px}"];
export { styles as styles };
